import Fingerprint2 from "fingerprintjs2";

import { logInformation } from "@/shared/logging/informations";

export class DeviceFingerprintProvider {
    public static getFingerprint(): Promise<string> {
        return new Promise((resolve) => {
            if (window.requestIdleCallback !== undefined) {
                window.requestIdleCallback(() => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component) => {
                            return component.value;
                        });
                        const fingerprint = Fingerprint2.x64hash128(values.join(""), 31);
                        logInformation("Fingerprint: " + fingerprint);
                        resolve(fingerprint);
                    });
                });
            } else {
                setTimeout(() => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component) => {
                            return component.value;
                        });
                        const fingerprint = Fingerprint2.x64hash128(values.join(""), 31);
                        logInformation("Fingerprint: " + fingerprint);
                        resolve(fingerprint);
                    });
                }, 500);
            }
        });
    }
}
